import React from "react";
import LayoutPage from "../../pages/services/LayoutPage";
import classes from "../../components/Services.module.css";
import AdvocatesAccFactoring from "../../components/Forms/AdvocatesAccFactoring";

function AdvocateFactoring() {
  return (
    <>
      <LayoutPage
        heading={"Advocate Accounts Factoring"}
        Form={
          <>
            <div
              style={{
                backgroundColor: "#113358",
                overflow: "hidden",
                borderRadius: "2%",
                padding: "20px",
              }}
            >
              <AdvocatesAccFactoring
                heading={
                  "Complete this form to apply for a Advocate Accounts Factoring"
                }
              />
            </div>
          </>
        }
      >
        <div className=" row">
          <div className="col-md-7 col-lg-7 mb-3 mb-md-0 bg-light">
            {" "}
            <h1 className={classes.h1}>Advocate Acounts Factoring</h1>
            <p className={classes.p}>
              We purchase your unpaid verified invoices. This product is kept
              completely confidential and private as you will be responsible to
              repay us yourself.
            </p>
            <h4 className={classes.h4}>
              How Long Until You Receive Your Funds?
            </h4>
            <p className={classes.p}>
              Funds are disbursed within 24 hours after the agreement is signed.
            </p>
          </div>
          <div className="col-md-4 col-lg-3">
            <div className={classes["background-image-div-5"]}></div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}
export default AdvocateFactoring;
